<template>
  <div class="number-picker">
    <button v-on:click="changeQuantity(-1)"></button>
    <input 
      type="number" 
      v-model="quantity"
      v-bind:id="id" 
      v-bind:min="min" 
      v-bind:max="max" 
      v-bind:step="step" 
      v-on:change="handleInput()"
    >
    <button v-on:click="changeQuantity(1)"></button>
  </div>
</template>

<script>
// Inspired by https://codepen.io/tobyj/pen/vGbpPj
export default {
  props: ['id', 'min', 'max', 'step', 'value'],
  data() {
    return {
      quantity: 0,
    }
  },
  mounted() {
    this.handleInput()
  },
  watch: {
    'value'() {
      this.setQuantity(this.value)
    }
  },
  methods: {
    handleInput() {
      let i = parseInt(this.quantity, 10)
      
      if ((i <= this.min) || (!i)) {
        this.quantity = this.min
      } else if (i >= this.max) {
        this.quantity = this.max
      }
      
      this.$emit('set-quantity', this.quantity, this.id)
    },
    changeQuantity(qty) {
      let q = parseInt(qty, 10),
          i = parseInt(this.quantity, 10)

      if ((i < this.max && (q > 0)) || (i > this.min && !(q > 0))) {
        this.quantity = i + q
        this.handleInput()
      }
    },
    setQuantity(qty) {
      this.quantity = qty
      this.handleInput()
    }
  }
}
</script>
